import Vue from 'vue';
import './scss-main/style.scss';
import PostComment from './main/comment/PostComment.vue';
import PostCommentJotType from './main/job/PostComment.vue';
import PostMentoring from './main/comment/PostMentoring.vue';
import BookingForm from './main/booking/BookingForm.vue';
import CounselForm from './main/counsel/CounselForm.vue';
import DetailModal from './main/resume/Detail.vue';
/*
import CounselFormTest from './main/counsel/CounselFormTest.vue';
*/
import PortalHomePost from './main/portal/PortalHomePost.vue';
import CourseForm from './main/education/CourseForm.vue';
import MypageEducationCalendar from './main/education/MypageEducationCalendar.vue';
import PortalAgit from './main/portal/PortalAgit.vue';
import SelfDiagnosis from './main/portal/SelfDiagnosis.vue';
import JobSelfDiagnosis from './main/job/SelfDiagnosis.vue';
import CalendarByRoom from './main/booking/CalendarByRoom.vue';
import CalendarByDate from './main/booking/CalendarByDate.vue';
import CommunityApplyTab from './main/community/CommunityTab.vue';
import PortalCalendar from './main/portal/PortalCalendar.vue';
import MypageMyInfo from './main/member/MyPageInfo.vue';
import IndividualInfo from './main/member/IndividualInfo.vue';
import MypageCommunityInfo from './main/community/MypageCommunityInfo.vue';
import MypageCommunityOperator from './main/community/AdminRequest.vue';
import CommunityJoinList from './main/community/CommunityJoinList.vue';
import MypageCommunityForm from './main/community/CommunityForm.vue';
import RestaurantCalendar from './main/shared/RestaurantCalendar.vue';
import AddWishButton from './main/education/AddWishButton.vue';
import AttendanceButton from './main/education/AttendanceButton.vue';
import MemberRejectButton from './main/community/MemberRejectButton.vue';
import MemberJoinButton from './main/community/MemberJoinButton.vue';
import CourseCancelButton from './main/education/CourseCancelButton.vue';
import CashInfoButton from './main/education/CashInfoButton.vue';
import MemberWriteForm from './main/member/MemberWriteForm.vue';
import OpenGov from './main/foundation/OpenGov.vue';
import LikeButton from './main/portal/LikeBtn.vue';
import LikeButtonJobType from './main/job/LikeBtn.vue';
import MemberRegist from './main/member/MemberRegist.vue';
import FindId from './main/member/FindId.vue';
import ChangePassword from './main/member/ChangePassword.vue';
import MypagePassword from './main/member/MypagePassword.vue';
import LoadMyDataButton from './main/member/LoadMyDataButton.vue';
import OrgModification from './main/foundation/OrgModification.vue';
import CompInfo from './main/member/CompInfo.vue';
import ResumeList from './main/resume/resumeList.vue';
import AppStatList from './main/member/APP/AppStatList.vue';
import ActList from './main/member/ACT/ActList.vue';
import ActJnlList from './main/member/ACT/ActJnlList.vue';
import FavoriteAnnList from './main/member/FavoriteAnnList.vue';
import MypageEducationDetail from './main/education/MypageEducationDetail.vue';
import AttendanceModal from './main/education/AttendanceModal.vue';
import MypageEducationJobLink from './main/education/MypageEducationJobLink.vue';
import EducationList from './main/education/EducationList.vue';
import CourseFormJobType from './main/education/CourseFormJobType.vue';
// import MypageCompApp from './main/member/comp/MypageCompApp.vue';
// import MypageEducationDetail from './main/education/MypageEducationDetail.vue';
import UnifiedSearchPage from './main/search/UnifiedSearchPage.vue';
import './main/education/EduApplicationModalIntegration';
import './main/education/RebateApplicationModalIntegration';
import FindIdJobType from './main/member/FindIdJobType.vue';
import ChangePasswordJobType from './main/member/ChangePasswordJobType.vue';
import InActJnlList from './main/member/ACT/InActJnlList.vue';

import MypageCompAppList from './main/member/comp/MypageCompAppList.vue';
import MyCompRecannList from './main/member/comp/MyCompRecannList.vue';
import MyCompAppRecannList from './main/member/comp/MyCompAppRecannList.vue';

Vue.mixin({
  methods: {
    globalDateFormat(date) {
      const year = date.getFullYear().toString().substr(2, 2);
      const mon = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      return `${year}${mon}${day}`;
    },
    globalGetInternetExplorerVersion() {
      let rv = 11; // Return value assumes failure.
      if (navigator.appName === 'Microsoft Internet Explorer') {
        const ua = navigator.userAgent;
        const re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})');
        if (re.exec(ua) != null) rv = parseFloat(RegExp.$1);
      }
      return rv;
    },
    globalEmailFormatter(email) {
      const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return re.test(email);
    },
    globalIntegerFormmatter(txt) {
      const idReg = /^[0-9]+$/;
      return idReg.test(txt);
    },
  },
});

export function comment(postId, isMemberPost, logined, photoUrl) {
  new Vue({ // eslint-disable-line no-new
    el: '#post-comment',
    data: {
      postId,
      isMemberPost,
      logined,
      photoUrl,
    },
    template: '<post-comment :postId="postId" :is-member-post="isMemberPost" :logined="logined" :photo-url="photoUrl"></post-comment>',
    components: {
      'post-comment': PostComment,
    },
  });
}

export function commentJobType(postId, isMemberPost, logined, photoUrl) {
  new Vue({ // eslint-disable-line no-new
    el: '#post-comment',
    data: {
      postId,
      isMemberPost,
      logined,
      photoUrl,
    },
    template: '<post-comment :postId="postId" :is-member-post="isMemberPost" :logined="logined" :photo-url="photoUrl"></post-comment>',
    components: {
      'post-comment': PostCommentJotType,
    },
  });
}

export function mentoring(postId, photoUrl) {
  new Vue({ // eslint-disable-line no-new
    el: '#post-mentoring',
    data: {
      postId,
      photoUrl,
    },
    template: '<post-mentoring :postId="postId" :photo-url="photoUrl"></post-mentoring>',
    components: {
      'post-mentoring': PostMentoring,
    },
  });
}

export function bookingForm(room, member, roomItems, communities, date, time) {
  new Vue({ // eslint-disable-line no-new
    el: '#booking-form',
    data: {
      room,
      member,
      roomItems,
      communities,
      date,
      time,
    },
    template: '<booking-form :room="room" :member="member" :room-items="roomItems" :communities="communities" :applyDate="applyDate" :strtTime="strtTime"></booking-form>',
    components: {
      'booking-form': BookingForm,
    },
  });
}

export function bookingFormCost(room, member, roomItems, communities, date, time, cost, exchange, siteCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#booking-form',
    data: {
      room,
      member,
      roomItems,
      communities,
      date,
      time,
      cost,
      exchange,
      siteCode,
    },
    template: '<booking-form :room="room" :member="member" :room-items="roomItems" :communities="communities" :applyDate="applyDate" :strtTime="strtTime" :cost="cost" :exchange="exchange" :site-code="siteCode"></booking-form>',
    components: {
      'booking-form': BookingForm,
    },
  });
}

export function counselForm(member, orgList, fieldList) {
  new Vue({ // eslint-disable-line no-new
    el: '#counsel-form',
    data: {
      member,
      orgList,
      fieldList,
    },
    template: '<counsel-form :member="member" :org-list="orgList" :field-list="fieldList"></counsel-form>',
    components: {
      'counsel-form': CounselForm,
    },
  });
}

/*
export function counselFormTest(member, orgList, fieldList) {
  new Vue({ // eslint-disable-line no-new
    el: '#counsel-form-test',
    data: {
      member,
      orgList,
      fieldList,
    },
    template: '<counsel-form-test :member="member"
                :org-list="orgList" :field-list="fieldList"></counsel-form-test>',
    components: {
      'counsel-form-test': CounselFormTest,
    },
  });
}
*/

export function portalHomePosts(initData, totalPages) {
  new Vue({ // eslint-disable-line no-new
    el: '#portal-home-post',
    data: {
      initData,
      totalPages,
    },
    template: '<portal-home-post :initData="initData" :totalPages="totalPages"></portal-home-post>',
    components: {
      'portal-home-post': PortalHomePost,
    },
  });
}

export function courseForm(member, lecture, forms, orgList, orgCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#course-form',
    data: {
      member,
      lecture,
      forms,
      orgList,
      orgCode,
    },
    template: '<course-form :member="member" :lecture="lecture" :forms="forms" :orgList="orgList" :orgCode="orgCode"></course-form>',
    components: {
      'course-form': CourseForm,
    },
  });
}

export function courseFormJobType(member, lecture, forms, orgList, orgCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#course-form',
    data: {
      member,
      lecture,
      forms,
      orgList,
      orgCode,
    },
    template: '<course-form :member="member" :lecture="lecture" :forms="forms" :orgList="orgList" :orgCode="orgCode"></course-form>',
    components: {
      'course-form': CourseFormJobType,
    },
  });
}

export function portalAgit(agitList) {
  new Vue({ // eslint-disable-line no-new
    el: '#portal-agit',
    data: {
      agitList,
    },
    template: '<portal-agit :agitList="agitList"></portal-agit>',
    components: {
      'portal-agit': PortalAgit,
    },
  });
}

export function portalSelfDiagnosis() {
  new Vue({ // eslint-disable-line no-new
    el: '#portal-self-diagnosis',
    data: {},
    template: '<self-diagnosis></self-diagnosis>',
    components: {
      'self-diagnosis': SelfDiagnosis,
    },
  });
}

export function jobSelfDiagnosis() {
  new Vue({ // eslint-disable-line no-new
    el: '#job-self-diagnosis',
    data: {},
    template: '<self-diagnosis></self-diagnosis>',
    components: {
      'self-diagnosis': JobSelfDiagnosis,
    },
  });
}

export function calendarByRoom(org, roomList) {
  new Vue({ // eslint-disable-line no-new
    el: '#calendar-by-room',
    data: {
      org,
      roomList,
    },
    template: '<calendar-by-room :org="org" :roomList="roomList"></calendar-by-room>',
    components: {
      'calendar-by-room': CalendarByRoom,
    },
  });
}

export function calendarByDate(room) {
  new Vue({ // eslint-disable-line no-new
    el: '#calendar-by-date',
    data: {
      room,
    },
    template: '<calendar-by-date :room="room"></calendar-by-date>',
    components: {
      'calendar-by-date': CalendarByDate,
    },
  });
}

export function communityApply(subject, orgList, member) {
  new Vue({ // eslint-disable-line no-new
    el: '#community-apply-tab',
    data: {
      subject,
      orgList,
      member,
    },
    template: '<community-apply-tab-template :subject="subject" :orgList="orgList" :member="member"></community-apply-tab-template>',
    components: {
      'community-apply-tab-template': CommunityApplyTab,
    },
  });
}

export function portalCalendar(schedules) {
  new Vue({ // eslint-disable-line no-new
    el: '#portal-calendar',
    data: {
      schedules,
    },
    template: '<portal-calendar :schedules="schedules"></portal-calendar>',
    components: {
      'portal-calendar': PortalCalendar,
    },
  });
}

export function mypageCalendar() {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-calendar',
    data: {},
    template: '<mypage-education-calendar></mypage-education-calendar>',
    components: {
      'mypage-education-calendar': MypageEducationCalendar,
    },
  });
}

export function mypageEducationJobLinkList(isLogin) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-education-job-link',
    data: {
      isLogin,
    },
    template: '<mypage-education-job-link :isLogin="isLogin"></mypage-education-job-link>',
    components: {
      'mypage-education-job-link': MypageEducationJobLink,
    },
  });
}

export function restaurantCalendar(org) {
  new Vue({ // eslint-disable-line no-new
    el: '#restaurant-menu-calendar',
    data: {
      org,
    },
    template: '<restaurant-menu-calendar :org="org"></restaurant-menu-calendar>',
    components: {
      'restaurant-menu-calendar': RestaurantCalendar,
    },
  });
}

export function mypageMyInfo(member, orgList, orgCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-myinfo-container',
    data: {
      member,
      orgList,
      orgCode,
    },
    template: '<mypage-myinfo-template :member="member" :orgList="orgList" :orgCode="orgCode"></mypage-myinfo-template>',
    components: {
      'mypage-myinfo-template': MypageMyInfo,
    },
  });
}

// 개인 회원 내정보 수정
export function individualInfo(member, orgList, orgCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-myinfo-container',
    data: {
      member,
      orgList,
      orgCode,
    },
    template: '<mypage-individualInfo-template :member="member" :orgList="orgList" :orgCode="orgCode"></mypage-individualInfo-template>',
    components: {
      'mypage-individualInfo-template': IndividualInfo,
    },
  });
}

// 기업 회원 내정보 수정
export function compInfo(member, orgList, orgCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-myinfo-container',
    data: {
      member,
      orgList,
      orgCode,
    },
    template: '<mypage-compinfo-template :member="member" :orgList="orgList" :orgCode="orgCode"></mypage-compinfo-template>',
    components: {
      'mypage-compinfo-template': CompInfo,
    },
  });
}

export function memberRejectButton(communityId, memberId, memberNm) {
  new Vue({ // eslint-disable-line no-new
    el: '#reject-btn',
    data: {
      communityId,
      memberId,
      memberNm,
    },
    template: '<reject-btn :communityId="communityId" :memberId="memberId" :memberNm="memberNm"></reject-btn>',
    components: {
      'reject-btn': MemberRejectButton,
    },
  });
}

export function memberJoinButton(communityId, loginMember, reJoinTxt) {
  new Vue({ // eslint-disable-line no-new
    el: '#join-btn',
    data: {
      communityId,
      loginMember,
      reJoinTxt,
    },
    template: '<join-btn :communityId="communityId" :loginMember="loginMember" :reJoinTxt="reJoinTxt"></join-btn>',
    components: {
      'join-btn': MemberJoinButton,
    },
  });
}

export function mypageCommunityInfo(member) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-community-info',
    data: {
      member,
    },
    template: '<homepage-mypage-community-info-template :member="member"></homepage-mypage-community-info-template>',
    components: {
      'homepage-mypage-community-info-template': MypageCommunityInfo,
    },
  });
}

export function mypageCommunityOperator(operatorList) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-community-operator',
    data: {
      operatorList,
    },
    template: '<homepage-mypage-community-operator-template :operatorList="operatorList"></homepage-mypage-community-operator-template>',
    components: {
      'homepage-mypage-community-operator-template': MypageCommunityOperator,
    },
  });
}

export function mypageCommunityList(communityList) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-community-list',
    data: {
      communityList,
    },
    template: '<mypage-community-list-template :communityList="communityList"></mypage-community-list-template>',
    components: {
      'mypage-community-list-template': CommunityJoinList,
    },
  });
}

export function mypageCommunityForm(post) {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-community-form',
    data: {
      post,
    },
    template: '<mypage-community-form-template :post="post"></mypage-community-form-template>',
    components: {
      'mypage-community-form-template': MypageCommunityForm,
    },
  });
}

export function addWishButton(lectureId) {
  new Vue({ // eslint-disable-line no-new
    el: '#add-wish-btn',
    data: {
      lectureId,
    },
    template: '<add-wish-btn :lecture-id="lectureId"></add-wish-btn>',
    components: {
      'add-wish-btn': AddWishButton,
    },
  });
}

export function detailButton(isLogin) {
  new Vue({ // eslint-disable-line no-new
    el: '#detail-button',
    data: {
      isLogin,
    },
    template: '<detail-modal :isLogin="isLogin"></detail-modal>',
    components: {
      'detail-modal': MypageEducationDetail,
    },
  });
}

export function attendanceButton() {
  new Vue({ // eslint-disable-line no-new
    el: '#attendance-button',
    data: {},
    template: '<attendance-btn></attendance-btn>',
    components: {
      'attendance-btn': AttendanceButton,
    },
  });
}

export function courseCancelButton() {
  new Vue({ // eslint-disable-line no-new
    el: '#course-cancel-button',
    data: {},
    template: '<course-cancel-btn></course-cancel-btn>',
    components: {
      'course-cancel-btn': CourseCancelButton,
    },
  });
}

// 전역 변수로 Vue 인스턴스 관리
let cashInfoButtonInstance = null;

export function cashInfoButton(cashInfoModal, courseId) {
  // 기존 인스턴스가 있으면 재사용
  if (cashInfoButtonInstance) {
    cashInfoButtonInstance.cashInfoModal = cashInfoModal;
    cashInfoButtonInstance.courseId = courseId;
  } else {
    // 새 인스턴스 생성
    cashInfoButtonInstance = new Vue({ // eslint-disable-line no-new
      el: '#cash-info-button',
      data: {
        cashInfoModal,
        courseId,
      },
      methods: {
        closeCashInfoModal() {
          this.cashInfoModal = false;
        },
      },
      template: '<cash-info-btn :cashInfoModal="cashInfoModal" :courseId="courseId" @update:cashInfoModal="closeCashInfoModal"></cash-info-btn>',
      components: {
        'cash-info-btn': CashInfoButton,
      },
    });
  }
}

export function memberWriteForm(org, postType) {
  new Vue({ // eslint-disable-line no-new
    el: '#member-write-form',
    data: {
      org,
      postType,
    },
    template: '<member-write-form-template :org="org" :post-type="postType"></member-write-form-template>',
    components: {
      'member-write-form-template': MemberWriteForm,
    },
  });
}

export function openGov() {
  new Vue({ // eslint-disable-line no-new
    el: '#opengov-container',
    data: {},
    template: '<open-gov-template></open-gov-template>',
    components: {
      'open-gov-template': OpenGov,
    },
  });
}

export function likeButton(likeCount, postId, isMemberPost) {
  new Vue({ // eslint-disable-line no-new
    el: '#like-btn',
    data: {
      likeCount,
      postId,
      isMemberPost,
    },
    template: '<like-btn :like-count="likeCount" :post-id="postId" :is-member-post="isMemberPost"></like-btn>',
    components: {
      'like-btn': LikeButton,
    },
  });
}

export function likeButtonJobType(likeCount, postId, isMemberPost) {
  new Vue({ // eslint-disable-line no-new
    el: '#like-btn',
    data: {
      likeCount,
      postId,
      isMemberPost,
    },
    template: '<like-btn :like-count="likeCount" :post-id="postId" :is-member-post="isMemberPost"></like-btn>',
    components: {
      'like-btn': LikeButtonJobType,
    },
  });
}

export function memberRegist(orgList, orgCode, sessionYear, sessionHp) {
  new Vue({ // eslint-disable-line no-new
    el: '#member-regist',
    data: {
      orgList,
      orgCode,
      sessionYear,
      sessionHp,
    },
    template: '<member-regist :org-list="orgList" :orgCode="orgCode" :sessionYear="sessionYear" :sessionHp="sessionHp"></member-regist>',
    components: {
      'member-regist': MemberRegist,
    },
  });
}

export function findId() {
  new Vue({ // eslint-disable-line no-new
    el: '#find-id-container',
    data: {
    },
    template: '<find-id></find-id>',
    components: {
      'find-id': FindId,
    },
  });
}

export function findIdJobType() {
  new Vue({ // eslint-disable-line no-new
    el: '#find-id-container',
    data: {
    },
    template: '<find-id></find-id>',
    components: {
      'find-id': FindIdJobType,
    },
  });
}

export function changePassword(loginId) {
  new Vue({ // eslint-disable-line no-new
    el: '#change-password-container',
    data: {
      loginId,
    },
    template: '<change-password :loginId="loginId"></change-password>',
    components: {
      'change-password': ChangePassword,
    },
  });
}

export function changePasswordJobType(loginId) {
  new Vue({ // eslint-disable-line no-new
    el: '#change-password-container',
    data: {
      loginId,
    },
    template: '<change-password :loginId="loginId"></change-password>',
    components: {
      'change-password': ChangePasswordJobType,
    },
  });
}

export function mypagePassword() {
  new Vue({ // eslint-disable-line no-new
    el: '#mypage-password-container',
    data: {
    },
    template: '<mypage-password></mypage-password>',
    components: {
      'mypage-password': MypagePassword,
    },
  });
}


export function loadMyDataButton(orgList) {
  new Vue({ // eslint-disable-line no-new
    el: '#load-my-data-button',
    data: {
      orgList,
    },
    template: '<load-my-data-btn :org-list="orgList"></load-my-data-btn>',
    components: {
      'load-my-data-btn': LoadMyDataButton,
    },
  });
}

export function orgModify(moduleId, orgCode) {
  new Vue({ // eslint-disable-line no-new
    el: '#org-modification-form',
    data: {
      moduleId,
      orgCode,
    },
    template: '<org-modification-form :moduleId="moduleId" :orgCode="orgCode"></org-modification-form>',
    components: {
      'org-modification-form': OrgModification,
    },
  });
}

export function resumeList(member) {
  new Vue({ // eslint-disable-line no-new
    el: '#resume-list-container',
    data: {
      member,
    },
    template: '<resume-list-container :member="member"></resume-list-container>',
    components: {
      'resume-list-container': ResumeList,
    },
  });
}

// 관리자 이력서 모달을 위한 export 함수 추가
export function adminResumeModal(indbankNo, memberName, options = {}) {
  const config = {
    adminMode: true,
    memberName,
    ...options,
  };

  // 완성도 값을 options에서 가져오고, 0-100 범위를 0-1 범위로 변환
  const completionRatePercent = options.completionRate || 0;
  const completionRate = completionRatePercent > 1
    ? completionRatePercent / 100
    : completionRatePercent;

  // 미리 로드된 코드 데이터 사용
  const resumeCodes = options.resumeCodes || {};

  return new Vue({
    el: options.el || '#admin-resume-modal-container',
    data: {
      indbankNo,
      memberName,
      detailModal: true,
      resume: {
        indbankNo,
        completionRate,
        title: `${memberName}님의 이력서` || `이력서 #${indbankNo}`,
      },
      config,
      codes: resumeCodes,
    },
    template: `
      <div class="admin-resume-modal" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 10050; display: block;">
        <detail-modal-template
          :detailModal="detailModal"
          :resume="resume"
          :adminMode="config.adminMode"
          :memberName="config.memberName"
          @closeDetailviewModal="closeModal"
        />
      </div>
    `,
    components: {
      'detail-modal-template': DetailModal,
    },
    methods: {
      closeModal() {
        this.detailModal = false;
        this.$el.style.display = 'none';
        document.body.classList.remove('modal-open');
        this.$destroy();
      },
    },
    mounted() {
      document.body.classList.add('modal-open');
    },
  });
}

// 전역으로 adminResume-modal 함수 노출
if (typeof window !== 'undefined') {
  window.adminResumeModal = adminResumeModal;
}

export function favoriteAnnList(isLogin) {
  new Vue({ // eslint-disable-line no-new
    el: '#favorite-ann-list-container',
    data: {
      isLogin,
    },
    template: '<favorite-ann-list-container :isLogin="isLogin"></favorite-ann-list-container>',
    components: {
      'favorite-ann-list-container': FavoriteAnnList,
    },
  });
}

export function attendanceModal(showModal, courseId) {
  new Vue({ // eslint-disable-line no-new
    el: '#attendance-button',
    data: {
      showModal, courseId,
    },
    template: '<attendance-modal :showModal="showModal" :courseId="courseId"></attendance-modal>',
    components: {
      'attendance-modal': AttendanceModal,
    },
  });
}

export function actList(annKindType) {
  new Vue({ // eslint-disable-line no-new
    el: '#act-list-container',
    data: {
      annKindType,
    },
    template: '<act-list-container :annKindType="annKindType"></act-list-container>',
    components: {
      'act-list-container': ActList,
    },
  });
}

export function actJnlList(annKindType, annNo, actCompNo, appNo) {
  new Vue({ // eslint-disable-line no-new
    el: '#act-jnl-list-container',
    data: {
      annKindType, annNo, actCompNo, appNo,
    },
    template: '<act-jnl-list-container :annKindType="annKindType" :annNo="annNo" :actCompNo="actCompNo" :appNo="appNo"></act-jnl-list-container>',
    components: {
      'act-jnl-list-container': ActJnlList,
    },
  });
}

export function inActJnlList(annKindType, annNo, actCompNo, appNo) {
  new Vue({ // eslint-disable-line no-new
    el: '#act-jnl-list-container',
    data: {
      annKindType, annNo, actCompNo, appNo,
    },
    template: '<act-jnl-list-container :annKindType="annKindType" :annNo="annNo" :actCompNo="actCompNo" :appNo="appNo"></act-jnl-list-container>',
    components: {
      'act-jnl-list-container': InActJnlList,
    },
  });
}

export function appStatList(annKindType, isCompanyMember) {
  new Vue({ // eslint-disable-line no-new
    el: '#app-stat-list-container',
    data: {
      annKindType,
      isCompanyMember,
    },
    methods: {
      appAdditionEdit() {
        alert('추가 입력 사항 수정');
      }
    },
    template: '<app-stat-list-container :annKindType="annKindType" :isCompanyMember="isCompanyMember" @appAdditionEdit="appAdditionEdit"></app-stat-list-container>',
    components: {
      'app-stat-list-container': AppStatList,
    },
  });
}

export function educationList(educationKind, orgList, searchDto) {
  new Vue({ // eslint-disable-line no-new
    el: '#education-list-container',
    data: {
      educationKind,
      orgList,
      searchDto,
    },
    template: '<education-list-container :educationKind="educationKind" :orgList="orgList" :searchDto="searchDto"></education-list-container>',
    components: {
      'education-list-container': EducationList,
    },
  });
}

// export function mypageCompAppContainer() {
//   new Vue({ // eslint-disable-line no-new
//     el: '#mypage-comp-app-container',
//     data: { },
//     template: '<mypage-comp-app-container></mypage-comp-app-container>',
//     components: {
//       'mypage-comp-app-container': MypageCompApp,
//     },
//   });
// }

export function mypageCompAppList() {
  new Vue({ // eslint-disable-line no-new
    el: "#mypage-comp-app-list",
    data: {},
    template: "<mypage-comp-app-list></mypage-comp-app-list>",
    components: {
      'mypage-comp-app-list': MypageCompAppList,
    },
  });
}

export function myCompRecannList() {
  new Vue({ // eslint-disable-line no-new
    el: "#mypage-comp-recann-list",
    data: {},
    template: "<mypage-comp-recann-list></mypage-comp-recann-list>",
    components: {
      'mypage-comp-recann-list': MyCompRecannList,
    },
  });
}

export function myCompAppRecannList(annNo) {
  new Vue({ // eslint-disable-line no-new
    el: "#mypage-comp-app-recann-list",
    data: {annNo},
    template: '<mypage-comp-app-recann-list :annNo="annNo"></mypage-comp-app-recann-list>',
    components: {
      'mypage-comp-app-recann-list': MyCompAppRecannList,
    },
  });
}

export function unifiedSearch(centerOrgsData = [], initialParams = {}) {
  new Vue({ // eslint-disable-line no-new
    el: '#unified-search-app',
    data: {
      centerOrgsData: centerOrgsData,
      initialParams: initialParams
    },
    template: '<unified-search-page :center-orgs-data="centerOrgsData" :initial-params="initialParams"></unified-search-page>',
    components: {
      'unified-search-page': UnifiedSearchPage,
    },
  });
}



// WEBPACK FOOTER //
// ./src/main.js